var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.58336C2.49713 10.6832 2.75411 11.7683 3.25 12.75C3.83797 13.9265 4.74188 14.916 5.86046 15.6078C6.97904 16.2995 8.26813 16.6662 9.58333 16.6667C10.6832 16.6696 11.7682 16.4126 12.75 15.9167L17.5 17.5L15.9167 12.75C16.4126 11.7683 16.6695 10.6832 16.6667 9.58336C16.6662 8.26815 16.2995 6.97907 15.6077 5.86048C14.916 4.7419 13.9265 3.838 12.75 3.25002C11.7682 2.75413 10.6832 2.49716 9.58333 2.50002H9.16667C7.42971 2.59585 5.78913 3.32899 4.55905 4.55907C3.32897 5.78915 2.59583 7.42973 2.5 9.16669V9.58336Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/messageCircle.64a75fa74bc568dc8536716e564c987e.svg";
export { ForwardRef as ReactComponent };